export default class BackendConstants {
    static limitMin: number = 10;
    static limit : number = 50;
    static messagesLimit: number = 15;
    static messagesTriggersLimit = {
        triggersLimit: 10,
        typesLimit: 10,
    }
    static LIMIT_MANAGER_TICKETS: number = 25;
}